import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import {
  fetchFaqCategoriesRequest,
  isFetchingFaqCategories,
  getFaqCategories
} from 'store/faq';

import { Content, Spinner } from 'components/Common';
import { Header, FaqQuestions } from 'components';
import { FaqAnswer } from 'containers';

export class Help extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    faqCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
    onFetchFaqCategories: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.onFetchFaqCategories();
  }

  render() {
    return (
      <div>
        <Header
          title={this.props.t('help.title')}
          description={this.props.t('help.description')}
        />

        <Content>
          {this.props.isFetching ? (
            <Spinner />
          ) : (
            <Switch>
              <Route
                path={`${this.props.match.url}/:id`}
                component={FaqAnswer}
              />
              <Route
                path={this.props.match.url}
                render={() => (
                  <FaqQuestions faqCategories={this.props.faqCategories} />
                )}
              />
              <Route render={() => <Redirect to={this.props.match.url} />} />
            </Switch>
          )}
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: isFetchingFaqCategories(state),
  faqCategories: getFaqCategories(state)
});

const mapDispatchToProps = {
  onFetchFaqCategories: fetchFaqCategoriesRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(Help));



// WEBPACK FOOTER //
// ./src/containers/Help/Help.js